const projects = [
    require('./humedades'),
    require('./morteros-tecnicos'),
    require('./decoracion'),
    require('./pintura'),
]

module.exports = projects.reduce((acc, _projects) => {
    acc[_projects.name] = _projects.projects
    return acc
}, {})



// WEBPACK FOOTER //
// ./src/data/projects.js